import { Collapse, IconButton, Skeleton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import ExpandIconButton from 'components/shared/buttons/ExpandIconButton';
import { ReactComponent as ArrowIcon } from 'assets/icons/sm-arrow-down.svg';

const FilterPanel = ({
  title,
  children,
  expand = true,
  open = false,
  sx = {},
  expandIconPosition = 'right', // 'right' | 'left'
  isLoading = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(open);

  const handleExpand = (e) => {
    e.target.blur();
    setIsExpanded((expanded) => !expanded);
  };

  const isLeft = expandIconPosition === 'left';

  return (
    <Stack spacing={2} sx={{ mb: 2, ...sx }}>
      <Stack
        direction="row"
        justifyContent={isLeft ? 'flex-start' : 'space-between'}
        alignItems="center"
        spacing={isLeft ? 1 : 0}
        className="title-container"
      >
        {isLeft && expand && (
          <ExpandIconButton
            disableRipple
            disableTouchRipple
            focusRipple={false}
            onClick={handleExpand}
            expand={isExpanded}
          >
            <ArrowIcon />
          </ExpandIconButton>
        )}

        <Typography variant="subtitle1" className="title" sx={{ fontSize: '16px', fontWeight: 500 }}>
          {title}
        </Typography>

        {!isLeft && expand && (
          <ExpandIconButton
            disableRipple
            disableTouchRipple
            focusRipple={false}
            onClick={handleExpand}
            expand={isExpanded}
          >
            <ArrowIcon />
          </ExpandIconButton>
        )}
      </Stack>

      <Collapse in={isExpanded} sx={{ mt: '0 !important' }} timeout="auto" mountOnEnter>
        <Stack spacing={2}>{children}</Stack>
      </Collapse>
    </Stack>
  );
};

export default FilterPanel;
